import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/services/api-client';
import type {
  ServiceProduct,
  ServiceProductKey,
  ServiceProductUpdateBody,
  ServiceProductsResponse,
} from '../types';

const QK = ['admin', 'service-products'] as const;

export function useServiceProducts() {
  return useQuery<ServiceProduct[]>({
    queryKey: QK,
    queryFn: async () => {
      const { data, error } = await apiClient.get<ServiceProductsResponse>('/ops/service-products');
      if (error) throw new Error(error.message);
      return data?.products || [];
    },
  });
}

export function useUpdateServiceProduct() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({
      key,
      body,
    }: {
      key: ServiceProductKey;
      body: ServiceProductUpdateBody;
    }) => {
      const { data, error } = await apiClient.put<{ product: ServiceProduct }>(
        `/ops/service-products/${key}`,
        body,
      );
      if (error) throw new Error(error.message);
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: QK });
      void qc.invalidateQueries({ queryKey: ['admin', 'license-recipes'] });
    },
  });
}
